import React from "react";

const Sparkle = ({ color = "#779be7" }) => (
  <svg
    className="h-auto w-16 sm:w-20 md:w-24 flex-shrink-0 absolute left-0 top-0 translate-x-2 -translate-y-8 -z-10 hidden md:block"
    fill="none"
    viewBox="0 0 91 98"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m35.878 14.162 1.333-5.369 1.933 5.183c4.47 11.982 14.036 21.085 25.828 24.467l5.42 1.555-5.209 2.16c-11.332 4.697-19.806 14.826-22.888 27.237l-1.333 5.369-1.933-5.183C34.56 57.599 24.993 48.496 13.201 45.114l-5.42-1.555 5.21-2.16c11.331-4.697 19.805-14.826 22.887-27.237Z"
      fill={color}
      stroke="#000"
      strokeWidth="3.445"
    />
    <path
      d="M79.653 5.729c-2.436 5.323-9.515 15.25-18.341 12.374m9.197 16.336c2.6-5.851 10.008-16.834 18.842-13.956m-9.738-15.07c-.374 3.787 1.076 12.078 9.869 14.943M70.61 34.6c.503-4.21-.69-13.346-9.49-16.214M14.922 65.967c1.338 5.677 6.372 16.756 15.808 15.659M18.21 95.832c-1.392-6.226-6.54-18.404-15.984-17.305m12.85-12.892c-.41 3.771-3.576 11.588-12.968 12.681M18.025 96c.367-4.21 3.453-12.905 12.854-14"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth="2.548"
    />
  </svg>
);
export default Sparkle;
